import { createSelector, createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { ISport } from "./ISport";

/**
 * Slimmed down to its single remaining responsibility: holding the
 * UI's currently-selected sport filter. The static catalog of sports
 * (formerly state.sports.sports[]) moved to TanStack Query in Phase 4b
 * — see src/api/hooks/sports.ts.
 *
 * Why this stays in Redux: the selected filter is read by multiple
 * components on different pages (ViewMatchesPage, LeagueAccordion,
 * filter chips on the feed) and writing it from one place must
 * trigger re-renders elsewhere. That's the textbook UI-state-in-Redux
 * pattern; pushing it into React Query (or URL state) would be more
 * invasive without buying us anything.
 */

export interface ISportsState {
  selectedSportFilter: ISport | null;
}

const initialState: ISportsState = {
  selectedSportFilter: null,
};

const sportsSlice = createSlice({
  name: "sports",
  initialState,
  reducers: {
    setSelectedSportFilter: (state, action: PayloadAction<ISport | null>) => {
      state.selectedSportFilter = action.payload;
    },
  },
});

const { reducer, actions } = sportsSlice;
export default reducer;
export const { setSelectedSportFilter } = actions;

export const selectedSportFilterSelector = createSelector(
  [(state: { sports: ISportsState }) => state.sports],
  (item) => item?.selectedSportFilter,
);
